module.exports = __webpack_public_path__ + "resources/img/img_codesign1_m_en.93f9e7ba072bda5db5dc8fb79954aedd.png";